// extracted by mini-css-extract-plugin
export default {"container":"fD5i6uJqIaJE7EcyuCTM","box":"LyctOq8d4bJeg73X0MdH","titleBlock":"Z3J18cSw4C4qLgcKCKlB","title":"qnYId8n2fNfOSzNfvDQi","description":"dorzTkRUAh1qdjxb3In1"};